import styled from "styled-components";
import { Button as ButtonDefault } from "../../../base/buttons/button/index.js";
import { Deals as DefaultDeals } from "../deals/index.js";
import { BoxShadow, BoxShadowHover } from "../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../styles/common/mixins/logical.styled.js";
export const BannerCampaignVertical = styled.a.withConfig({
    displayName: "styled__BannerCampaignVertical",
    componentId: "sc-58a085bb-0"
})`
	${BorderRadius({
    all: '4px'
})};
	${FlexMixin({
    justify: 'center'
})};
	${BoxShadow};
	${({ $modifiyHoverCard  })=>$modifiyHoverCard ? BoxShadowHover : ''};
	width: 365px;
	min-width: 365px;
	overflow: hidden;
	position: relative;
	transition: box-shadow 0.2s cubic-bezier(0.25, 0.8, 0.25, 0.1);

	${({ $modifiyHoverCard  })=>`
    	&:hover {
			.image-banner {
				img {
					transform: ${$modifiyHoverCard ? '' : 'scale(1.1)'};
				}
			}
		}
  `}

	& > a {
		width: 100%;
	}
	.image-banner {
		height: 100%;

		img {
			object-fit: cover;
			width: 100%;
			${({ $modifiyHoverCard  })=>`transition: ${$modifiyHoverCard ? '' : 'transform 1s'};`}
		}
	}

	&.is-tablet {
		${FlexMixin({
    justify: 'flex-start'
})};
		width: calc(100% - 4px);
		margin-left: 2px;
		min-width: unset;
		height: auto;
		min-height: 152px;

		.image-banner {
			${FlexMixin({
    justify: 'center',
    align: 'center'
})};
			position: absolute;
			right: 0;
			width: 60%;

			img {
				object-fit: fill;
				width: 100%;
				transition: none;
			}
		}
	}
`;
export const BannerCampaignVerticalContainer = styled.div.withConfig({
    displayName: "styled__BannerCampaignVerticalContainer",
    componentId: "sc-58a085bb-1"
})`
	text-align: center;
	background-color: ${({ theme  })=>theme.colors.white.base};
	position: absolute;
	padding: 16px 12px 32px;
	bottom: 0;
	left: 0;
	right: 0;

	&.is-tablet {
		position: relative;
		width: 40%;
		padding: 12px 16px;
		z-index: 1;

		::before {
			background-color: white;
			height: calc(100% + 24px);
			width: 46px;
			content: '';
			position: absolute;
			top: -12px;
			right: -16px;
			transform: skew(10deg);
			z-index: -1;
		}
	}
`;
export const Title = styled.p.withConfig({
    displayName: "styled__Title",
    componentId: "sc-58a085bb-2"
})`
	position: relative;
	${FontMixin({
    size: 'largest',
    weight: 'bold',
    height: 'largest'
})};
	color: ${({ theme  })=>theme.colors.primary.light};

	&.is-tablet {
		${FontMixin({
    weight: 'medium'
})};
		line-height: 42px;
	}
`;
export const Subtitle = styled.p.withConfig({
    displayName: "styled__Subtitle",
    componentId: "sc-58a085bb-3"
})`
	${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'base'
})};
	color: ${({ theme  })=>theme.colors.primary.light};
	margin-bottom: 16px;
	position: relative;

	&.is-tablet {
		${FontMixin({
    weight: 'regular'
})};
		font-weight: 400;
		line-height: 22px;
		margin-bottom: 16px;
	}
`;
export const Button = styled(ButtonDefault).withConfig({
    displayName: "styled__Button",
    componentId: "sc-58a085bb-4"
})`
	margin-bottom: unset;
	position: relative;

	&.is-tablet {
		${FontMixin({
    size: 'medium',
    weight: 'medium',
    height: 'base'
})};
		position: unset;
	}
`;
export const Deals = styled(DefaultDeals).withConfig({
    displayName: "styled__Deals",
    componentId: "sc-58a085bb-5"
})`
	padding: 12px 16px;

	&.is-tablet {
		border-bottom-right-radius: 4px;
		border-bottom-left-radius: 4px;
		margin: 0;
		height: 70px;
		right: 16px;
		min-width: unset;
		max-width: unset;
		width: auto;
	}
`;

//# sourceMappingURL=styled.js.map